import { Pipe, type PipeTransform } from '@angular/core';

@Pipe({ name: 'includes' })
export class IncludesPipe implements PipeTransform {
  transform<T>(array: T[], value: T) {
    return array.includes(value);
  }
}
